// extracted by mini-css-extract-plugin
export default {"Container":"ChildPageContent_Container__dOH9F","ChildLink":"ChildPageContent_ChildLink__kT5CO"};